import { buildCompanyUrl } from '~/utils/formatters'

interface BreadcrumbItemElement {
  '@type': string
  'position': number
  'name': string
  'item': string
}
interface BreadcrumbList {
  '@context': string
  '@type': string
  'itemListElement': BreadcrumbItemElement[]
}
interface BreadcrumbOptions {
  companyName?: string
  companySlug?: string
  section?: string
  location?: {
    city: string | null
    state: string | null
  }
  roleParam?: string | null
}
export function generateBreadcrumbSchema({
  companyName = '',
  companySlug = '',
  section = '',
  location = { city: null, state: null },
  roleParam = null
}: BreadcrumbOptions): BreadcrumbList {
  const breadcrumbs: BreadcrumbItemElement[] = []
  let position = 1
  breadcrumbs.push({
    '@type': 'ListItem',
    'position': position++,
    'name': 'Companies',
    'item': 'https://employers.io/company'
  })
  if (companyName && companySlug) {
    breadcrumbs.push({
      '@type': 'ListItem',
      'position': position++,
      'name': companyName,
      'item': `https://employers.io/company/${companySlug}`
    })
  }
  if (section && section !== 'overview') {
    let sectionName = section.charAt(0).toUpperCase() + section.slice(1)
    if (section === 'drug-test-policy') {
      sectionName = 'Drug Test Policy'
    }
    breadcrumbs.push({
      '@type': 'ListItem',
      'position': position++,
      'name': sectionName,
      'item': `https://employers.io/company/${companySlug}/${section}`
    })
  }
  if (location && (location.state || location.city)) {
    let locationName = ''
    if (location.city && location.state) {
      locationName = `${location.city}, ${location.state}`
    } else if (location.state) {
      locationName = location.state
    }

    const locationUrl = buildCompanyUrl(companySlug, section as 'salaries' | 'reviews', {
      city: location.city || undefined,
      stateCode: location.state || undefined
    })

    if (locationName && locationUrl) {
      breadcrumbs.push({
        '@type': 'ListItem',
        'position': position++,
        'name': locationName,
        'item': `https://employers.io${locationUrl}`
      })
    }
  }
  if (roleParam) {
    const roleName = roleParam.replace(/-/g, ' ')

    const roleUrl = buildCompanyUrl(companySlug, section as 'salaries' | 'reviews', {
      city: location?.city || undefined,
      stateCode: location?.state || undefined,
      role: roleParam
    })

    breadcrumbs.push({
      '@type': 'ListItem',
      'position': position++,
      'name': roleName,
      'item': `https://employers.io${roleUrl}`
    })
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': breadcrumbs
  }
}
